export const filesApi = 'files';
export const thumbnailsApi = `${filesApi}/thumbnails`;
export const compressedApi = `${filesApi}/compressed`;
